import { IconProps } from "../../utils/global-types/global-types";

const CrmDashboardIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10 7.5a.48.48 0 0 1-.356-.144A.48.48 0 0 1 9.5 7V3.5q0-.212.144-.356A.48.48 0 0 1 10 3h4.5q.213 0 .356.144A.48.48 0 0 1 15 3.5V7q0 .213-.144.356a.48.48 0 0 1-.356.144zm-6.5 2a.48.48 0 0 1-.356-.144A.48.48 0 0 1 3 9V3.5q0-.212.144-.356A.48.48 0 0 1 3.5 3H8q.212 0 .356.144A.48.48 0 0 1 8.5 3.5V9q0 .212-.144.356A.48.48 0 0 1 8 9.5zM10 15a.48.48 0 0 1-.356-.144.48.48 0 0 1-.144-.356V9q0-.212.144-.356A.48.48 0 0 1 10 8.5h4.5q.213 0 .356.144A.48.48 0 0 1 15 9v5.5q0 .213-.144.356A.48.48 0 0 1 14.5 15zm-6.5 0a.48.48 0 0 1-.356-.144A.48.48 0 0 1 3 14.5V11q0-.213.144-.356A.48.48 0 0 1 3.5 10.5H8q.212 0 .356.144A.48.48 0 0 1 8.5 11v3.5q0 .213-.144.356A.48.48 0 0 1 8 15z"
      ></path>
    </svg>
  );
};

export default CrmDashboardIcon;
